module.exports = __webpack_public_path__ + "media/images/emblems/Luetzelflueh-coat_of_arms-958b17f6c86aa83a58c9d18a1f0fc5b0.svg";